import CancelFlow from "./CancelFlow";

interface CancelDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function CancelDialog({ open, onClose }: CancelDialogProps) {
  return <CancelFlow open={open} closeDialog={onClose} />;
}
